export const STATUS_META = {
  paid: { label: 'Pagato', color: '#4da8ff', hint: 'Da preparare' },
  processing: { label: 'In lavorazione', color: '#ffb347', hint: 'In preparazione' },
  shipped: { label: 'Spedito', color: '#ff69b4', hint: 'In viaggio' },
  delivered: { label: 'Consegnato', color: '#39d98a', hint: 'Completato' },
  cancelled: { label: 'Annullato', color: '#8a8a94', hint: '' },
  refunded: { label: 'Rimborsato', color: '#f87171', hint: '' },
};

export const STATUS_ORDER = ['paid', 'processing', 'shipped', 'delivered', 'cancelled', 'refunded'];
export const ACTIVE_STATUSES = ['paid', 'processing', 'shipped'];
export const ARCHIVED_STATUSES = ['delivered', 'cancelled', 'refunded'];

export const TRANSITIONS = {
  paid: ['processing', 'shipped', 'cancelled', 'refunded'],
  processing: ['paid', 'shipped', 'cancelled', 'refunded'],
  shipped: ['processing', 'delivered', 'refunded'],
  delivered: ['shipped', 'refunded'],
  cancelled: ['paid'],
  refunded: [],
};

export const fmtMoney = (n, currency = 'eur') => new Intl.NumberFormat('it-IT', { style: 'currency', currency: currency.toUpperCase() }).format(Number(n || 0));

export const fmtDate = (value, withTime = true) => {
  if (!value) return '—';
  const d = new Date(value);
  return d.toLocaleString('it-IT', withTime ? { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' } : { day: '2-digit', month: '2-digit', year: '2-digit' });
};

export const itemsCount = (order) => (order.items || []).reduce((n, i) => n + Number(i.quantity || 0), 0);

export const customerLabel = (order) => order.customer?.name || order.shipping_address?.name || order.customer?.email || 'Cliente sconosciuto';

export const hasAddress = (order) => Boolean(order.shipping_address?.line1 && order.shipping_address?.city);
